export default "__VITE_ASSET__Bh8Eub3W__"